import m from "mithril";

export default {
	blank: [],
	chocolate: [
		m("rect", {
			x: 2,
			y: 2,
			width: 4,
			height: 4,
		}),
		m("rect", {
			x: 2,
			y: 10,
			width: 4,
			height: 4,
		}),
		m("rect", {
			x: 2,
			y: 18,
			width: 4,
			height: 4,
		}),
		m("rect", {
			x: 10,
			y: 2,
			width: 4,
			height: 4,
		}),
		m("rect", {
			x: 10,
			y: 10,
			width: 4,
			height: 4,
		}),
		m("rect", {
			x: 10,
			y: 18,
			width: 4,
			height: 4,
		}),
		m("rect", {
			x: 18,
			y: 2,
			width: 4,
			height: 4,
		}),
		m("rect", {
			x: 18,
			y: 10,
			width: 4,
			height: 4,
		}),
		m("rect", {
			x: 18,
			y: 18,
			width: 4,
			height: 4,
		}),
	],
	add: [
		m("circle", {
			cx: "12",
			cy: "12",
			r: "10",
		}),
		m("line", {
			x1: "12",
			y1: "8",
			x2: "12",
			y2: "16",
		}),
		m("line", {
			x1: "8",
			y1: "12",
			x2: "16",
			y2: "12",
		}),
	],
	home: [
		m("path", {
			d: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
		}),
		m("polyline", {
			points: "9 22 9 12 15 12 15 22",
		}),
	],
	burger: [
		m("line", {
			x1: "3",
			y1: "12",
			x2: "21",
			y2: "12",
		}),
		m("line", {
			x1: "3",
			y1: "6",
			x2: "21",
			y2: "6",
		}),
		m("line", {
			x1: "3",
			y1: "18",
			x2: "21",
			y2: "18",
		}),
	],
	setting: [
		m("circle", {
			cx: "12",
			cy: "12",
			r: "3",
		}),
		m("path", {
			d: "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z",
		}),
	],
	copy: [
		m("rect", {
			x: "9",
			y: "9",
			width: "13",
			height: "13",
			rx: "2",
			ry: "2",
		}),
		m("path", {
			d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1",
		}),
	],
	"no-file-icon": [
		m("path", {d: "M14 2H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V8l-6-6z"}),
		m("path", {d: "M14 3v5h5M9.9 17.1L14 13M9.9 12.9L14 17"}),
	],
	"file-icon": [
		m("path", {d: "M14 2H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V8l-6-6z"}),
		m("path", {d: "M14 3v5h5M16 13H8M16 17H8M10 9H8"}),
	],
	"file-added": [
		m("path", {
			d: "M14 2H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V8l-6-6z",
		}),
		m("path", {
			d: "M14 3v5h5M12 18v-6M9 15h6",
		}),
	],
	move: [
		m("path", {
			d: "M5.2 9l-3 3 3 3M9 5.2l3-3 3 3M15 18.9l-3 3-3-3M18.9 9l3 3-3 3M3.3 12h17.4M12 3.2v17.6",
		}),
	],
	checkblank: [
		m("rect", {
			x: "3",
			y: "3",
			width: "18",
			height: "18",
			rx: "2",
			ry: "2",
		}),
	],
	checkticked: [
		m("polyline", {
			points: "9 11 12 14 22 4",
		}),
		m("path", {
			d: "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11",
		}),
	],
	activitydone: [
		m("path", {
			d: "M22 11.08V12a10 10 0 1 1-5.93-9.14",
		}),
		m("polyline", {
			points: "22 4 12 14.01 9 11.01",
		}),
	],
	activitypending: [
		m("circle", {
			cx: "12",
			cy: "12",
			r: "10",
		}),
	],
	activitydue: [
		m("path", {
			d: "M22 17H2a3 3 0 0 0 3-3V9a7 7 0 0 1 14 0v5a3 3 0 0 0 3 3zm-8.27 4a2 2 0 0 1-3.46 0",
		}),
	],
	bell: [
		m("path", {
			d: "M22 17H2a3 3 0 0 0 3-3V9a7 7 0 0 1 14 0v5a3 3 0 0 0 3 3zm-8.27 4a2 2 0 0 1-3.46 0",
		}),
	],
	delete: [
		m("circle", {
			cx: "12",
			cy: "12",
			r: "10",
		}),
		m("line", {
			x1: "15",
			y1: "9",
			x2: "9",
			y2: "15",
		}),
		m("line", {
			x1: "9",
			y1: "9",
			x2: "15",
			y2: "15",
		}),
	],
	"refresh-cw": [
		m("path", {
			d: "M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38",
		}),
	],
	loader: [
		m("line", {
			x1: "12",
			y1: "2",
			x2: "12",
			y2: "6",
		}),
		m("line", {
			x1: "12",
			y1: "18",
			x2: "12",
			y2: "22",
		}),
		m("line", {
			x1: "4.93",
			y1: "4.93",
			x2: "7.76",
			y2: "7.76",
		}),
		m("line", {
			x1: "16.24",
			y1: "16.24",
			x2: "19.07",
			y2: "19.07",
		}),
		m("line", {
			x1: "2",
			y1: "12",
			x2: "6",
			y2: "12",
		}),
		m("line", {
			x1: "18",
			y1: "12",
			x2: "22",
			y2: "12",
		}),
		m("line", {
			x1: "4.93",
			y1: "19.07",
			x2: "7.76",
			y2: "16.24",
		}),
		m("line", {
			x1: "16.24",
			y1: "7.76",
			x2: "19.07",
			y2: "4.93",
		}),
	],
	rotate: [
		m("path", {
			d: "M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2",
		}),
	],
	filter: [
		m("polygon", {
			points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3",
		}),
	],
	"no-filter": [
		m("polygon", {
			points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3",
		}),
		m("line", {
			y2: "13.3",
			x2: "21",
			y1: "13.3",
			x1: "3",
		}),
	],
	edit: [
		m("path", {
			d: "M20 14.66V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.34",
		}),
		m("polygon", {
			points: "18 2 22 6 12 16 8 16 8 12 18 2",
		}),
	],
	share: [
		m("circle", {
			cx: "18",
			cy: "5",
			r: "3",
		}),
		m("circle", {
			cx: "6",
			cy: "12",
			r: "3",
		}),
		m("circle", {
			cx: "18",
			cy: "19",
			r: "3",
		}),
		m("line", {
			x1: "8.59",
			y1: "13.51",
			x2: "15.42",
			y2: "17.49",
		}),
		m("line", {
			x1: "15.41",
			y1: "6.51",
			x2: "8.59",
			y2: "10.49",
		}),
	],
	grid: [
		m("rect", {
			x: "3",
			y: "3",
			width: "7",
			height: "7",
		}),
		m("rect", {
			x: "14",
			y: "3",
			width: "7",
			height: "7",
		}),
		m("rect", {
			x: "14",
			y: "14",
			width: "7",
			height: "7",
		}),
		m("rect", {
			x: "3",
			y: "14",
			width: "7",
			height: "7",
		}),
	],
	"recording-start": [
		m("path", {
			d: "M15.6 11.6L22 7v10l-6.4-4.5v-1zM4 5h9a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7c0-1.1.9-2 2-2z",
		}),
	],
	"recording-stop": [
		m("path", {
			d: "M2 2l19.8 19.8M15 15.7V17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7c0-1.1.9-2 2-2h.3m5.4 0H13a2 2 0 0 1 2 2v3.3l1 1L22 7v10",
		}),
	],
	"stop-icon": [m("circle", {cx: "12", cy: "12", r: "10"}), m("rect", {x: "9", y: "9", width: "6", height: "6"})],
	sliders: [
		m("line", {
			x1: "4",
			y1: "21",
			x2: "4",
			y2: "14",
		}),
		m("line", {
			x1: "4",
			y1: "10",
			x2: "4",
			y2: "3",
		}),
		m("line", {
			x1: "12",
			y1: "21",
			x2: "12",
			y2: "12",
		}),
		m("line", {
			x1: "12",
			y1: "8",
			x2: "12",
			y2: "3",
		}),
		m("line", {
			x1: "20",
			y1: "21",
			x2: "20",
			y2: "16",
		}),
		m("line", {
			x1: "20",
			y1: "12",
			x2: "20",
			y2: "3",
		}),
		m("line", {
			x1: "1",
			y1: "14",
			x2: "7",
			y2: "14",
		}),
		m("line", {
			x1: "9",
			y1: "8",
			x2: "15",
			y2: "8",
		}),
		m("line", {
			x1: "17",
			y1: "16",
			x2: "23",
			y2: "16",
		}),
	],
	download: [
		m("path", {
			d: "M3 15v4c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2v-4M17 9l-5 5-5-5M12 12.8V2.5",
		}),
	],
	upload: [
		m("path", {
			d: "M3 15v4c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2v-4M17 8l-5-5-5 5M12 4.2v10.3",
		}),
	],
	"arrow-right-circle": [
		m("circle", {
			cx: "12",
			cy: "12",
			r: "10",
		}),
		m("path", {
			d: "M12 8l4 4-4 4M8 12h7",
		}),
	],
	"arrow-left-circle": [
		m("circle", {
			cx: "12",
			cy: "12",
			r: "10",
		}),
		m("path", {
			d: "M12 8l-4 4 4 4M16 12H9",
		}),
	],
	shuffle: [
		m("path", {
			d: "M16 3h5v5M4 20L20.2 3.8M21 16v5h-5M15 15l5.1 5.1M4 4l5 5",
		}),
	],
	"trending-up": [
		m("path", {
			d: "M20.2 7.8l-7.7 7.7-4-4-5.7 5.7",
		}),
		m("path", {
			d: "M15 7h6v6",
		}),
	],
	"trending-down": [
		m("path", {
			d: "M20.2 17.2l-7.7-7.7-4 4-5.7-5.7",
		}),
		m("path", {
			d: "M15 18h6v-6",
		}),
	],
	help: [
		m("circle", {
			cx: "12",
			cy: "12",
			r: "10",
		}),
		m("path", {
			d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3",
		}),
		m("line", {
			x1: "12",
			y1: "17",
			x2: "12",
			y2: "17",
		}),
	],
	"clear-delete": [
		m("line", {
			x1: "18",
			y1: "6",
			x2: "6",
			y2: "18",
		}),
		m("line", {
			x1: "6",
			y1: "6",
			x2: "18",
			y2: "18",
		}),
	],
	"triangle-right": [
		m("polygon", {
			points: "5 3 19 12 5 21 5 3",
		}),
	],
	"chevron-down": [
		m("path", {
			d: "M6 9l6 6 6-6",
		}),
	],
};
